/* eslint-disable react/prop-types */
import {useContext} from 'react'
import {useNavigate} from 'react-router-dom'

import Context from '@s-ui/react-context'
import CardConfigurator from '@adv-mt/mt-card-configurator'
import TitleBasic, {titleBasicColors, titleBasicSizes, titleBasicTextAlign} from '@adv-mt/mt-title-basic'
import {useAnalyticsTrack} from '@adv-mt/mt-tracking-use-analytics'

import {DEFAULT_CONFIGURATOR_IMAGE_URL} from '../utils.js'

export const CarConfiguratorAccess = ({filterVehicle, configuratorData, hasResults}) => {
  const {i18n} = useContext(Context)
  const navigate = useNavigate()
  const {track} = useAnalyticsTrack()

  const make = configuratorData.make?.name || filterVehicle?.make?.name || ''
  const model = filterVehicle?.model?.name || ''
  const title = i18n.t(
    hasResults ? 'CONFIGURATOR.LISTING_ACCESS_FEW_RESULTS_TITLE' : 'CONFIGURATOR.LISTING_ACCESS_NO_RESULTS_TITLE',
    {make, model}
  )

  const description = i18n.t(
    hasResults
      ? 'CONFIGURATOR.LISTING_ACCESS_FEW_RESULTS_DESCRIPTION'
      : 'CONFIGURATOR.LISTING_ACCESS_NO_RESULTS_DESCRIPTION',
    {make, model}
  )

  const showDefaultImage = Boolean(filterVehicle?.model?.name) === false

  /** TechDebt: MTR-97853 - Im currently working on a domain use case to get the configuration from there */
  const _handleConfigureClick = e => {
    e.preventDefault()
    track({
      event: 'Car Configurator Access Clicked',
      data: {
        hit_information: 'listing page'
      }
    })
    navigate(configuratorData.configuratorUrl)
  }

  return (
    <div className="mt-AdsList-cardConfigurator">
      <div className="mt-AdsList-cardConfiguratorTitle">
        <TitleBasic
          title={title}
          description={description}
          size={titleBasicSizes.xs}
          textAlign={titleBasicTextAlign.CENTER}
          color={titleBasicColors.DARK}
        />
      </div>
      <CardConfigurator
        make={make}
        model={model}
        imageUrl={showDefaultImage ? DEFAULT_CONFIGURATOR_IMAGE_URL : configuratorData.images?.[0]}
        priceFrom={`${i18n.n(configuratorData.price)} €`}
        href={configuratorData.configuratorUrl}
        onConfiguratorClick={_handleConfigureClick}
      />
    </div>
  )
}
